"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountLogo = exports.AccountTitle = void 0;
const stitches_config_1 = require("../../../stitches.config");
const AccountLogoStyle = {
    width: 40,
    height: 40,
    minWidth: 40,
    borderRadius: 20,
    variants: {
        size: {
            "32": {
                width: 32,
                minWidth: 32,
                height: 32,
                lineHeight: "32px",
                fontSize: 20,
            },
            "28": {
                width: 28,
                minWidth: 28,
                height: 28,
                lineHeight: "28px",
                fontSize: 18,
            },
        },
        displayPrintOnly: {
            true: {
                "@media screen": {
                    display: "none",
                },
                "@media print": {
                    display: "block",
                },
            },
        },
    },
};
exports.AccountTitle = (0, stitches_config_1.styled)("div", {
    ...AccountLogoStyle,
    background: stitches_config_1.colors.blue500,
    textAlign: "center",
    fontSize: 24,
    color: stitches_config_1.colors.contentPrimaryInverted,
    lineHeight: "40px",
});
exports.AccountLogo = (0, stitches_config_1.styled)("img", {
    ...AccountLogoStyle,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWNjb3VudExvZ28uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0NvbW1vbi9fX3N0eWxlc19fL0FjY291bnRMb2dvLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDhEQUEwRDtBQUUxRCxNQUFNLGdCQUFnQixHQUFHO0lBQ3ZCLEtBQUssRUFBRSxFQUFFO0lBQ1QsTUFBTSxFQUFFLEVBQUU7SUFDVixRQUFRLEVBQUUsRUFBRTtJQUNaLFlBQVksRUFBRSxFQUFFO0lBQ2hCLFFBQVEsRUFBRTtRQUNSLElBQUksRUFBRTtZQUNKLElBQUksRUFBRTtnQkFDSixLQUFLLEVBQUUsRUFBRTtnQkFDVCxRQUFRLEVBQUUsRUFBRTtnQkFDWixNQUFNLEVBQUUsRUFBRTtnQkFDVixVQUFVLEVBQUUsTUFBTTtnQkFDbEIsUUFBUSxFQUFFLEVBQUU7YUFDYjtZQUNELElBQUksRUFBRTtnQkFDSixLQUFLLEVBQUUsRUFBRTtnQkFDVCxRQUFRLEVBQUUsRUFBRTtnQkFDWixNQUFNLEVBQUUsRUFBRTtnQkFDVixVQUFVLEVBQUUsTUFBTTtnQkFDbEIsUUFBUSxFQUFFLEVBQUU7YUFDYjtTQUNGO1FBQ0QsZ0JBQWdCLEVBQUU7WUFDaEIsSUFBSSxFQUFFO2dCQUNKLGVBQWUsRUFBRTtvQkFDZixPQUFPLEVBQUUsTUFBTTtpQkFDaEI7Z0JBQ0QsY0FBYyxFQUFFO29CQUNkLE9BQU8sRUFBRSxPQUFPO2lCQUNqQjthQUNGO1NBQ0Y7S0FDRjtDQUNGLENBQUM7QUFFVyxRQUFBLFlBQVksR0FBRyxJQUFBLHdCQUFNLEVBQUMsS0FBSyxFQUFFO0lBQ3hDLEdBQUcsZ0JBQWdCO0lBQ25CLFVBQVUsRUFBRSx3QkFBTSxDQUFDLE9BQU87SUFDMUIsU0FBUyxFQUFFLFFBQVE7SUFDbkIsUUFBUSxFQUFFLEVBQUU7SUFDWixLQUFLLEVBQUUsd0JBQU0sQ0FBQyxzQkFBc0I7SUFDcEMsVUFBVSxFQUFFLE1BQU07Q0FDbkIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxXQUFXLEdBQUcsSUFBQSx3QkFBTSxFQUFDLEtBQUssRUFBRTtJQUN2QyxHQUFHLGdCQUFnQjtDQUNwQixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjb2xvcnMsIHN0eWxlZCB9IGZyb20gXCIuLi8uLi8uLi9zdGl0Y2hlcy5jb25maWdcIjtcblxuY29uc3QgQWNjb3VudExvZ29TdHlsZSA9IHtcbiAgd2lkdGg6IDQwLFxuICBoZWlnaHQ6IDQwLFxuICBtaW5XaWR0aDogNDAsXG4gIGJvcmRlclJhZGl1czogMjAsXG4gIHZhcmlhbnRzOiB7XG4gICAgc2l6ZToge1xuICAgICAgXCIzMlwiOiB7XG4gICAgICAgIHdpZHRoOiAzMixcbiAgICAgICAgbWluV2lkdGg6IDMyLFxuICAgICAgICBoZWlnaHQ6IDMyLFxuICAgICAgICBsaW5lSGVpZ2h0OiBcIjMycHhcIixcbiAgICAgICAgZm9udFNpemU6IDIwLFxuICAgICAgfSxcbiAgICAgIFwiMjhcIjoge1xuICAgICAgICB3aWR0aDogMjgsXG4gICAgICAgIG1pbldpZHRoOiAyOCxcbiAgICAgICAgaGVpZ2h0OiAyOCxcbiAgICAgICAgbGluZUhlaWdodDogXCIyOHB4XCIsXG4gICAgICAgIGZvbnRTaXplOiAxOCxcbiAgICAgIH0sXG4gICAgfSxcbiAgICBkaXNwbGF5UHJpbnRPbmx5OiB7XG4gICAgICB0cnVlOiB7XG4gICAgICAgIFwiQG1lZGlhIHNjcmVlblwiOiB7XG4gICAgICAgICAgZGlzcGxheTogXCJub25lXCIsXG4gICAgICAgIH0sXG4gICAgICAgIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgIH0sXG4gIH0sXG59O1xuXG5leHBvcnQgY29uc3QgQWNjb3VudFRpdGxlID0gc3R5bGVkKFwiZGl2XCIsIHtcbiAgLi4uQWNjb3VudExvZ29TdHlsZSxcbiAgYmFja2dyb3VuZDogY29sb3JzLmJsdWU1MDAsXG4gIHRleHRBbGlnbjogXCJjZW50ZXJcIixcbiAgZm9udFNpemU6IDI0LFxuICBjb2xvcjogY29sb3JzLmNvbnRlbnRQcmltYXJ5SW52ZXJ0ZWQsXG4gIGxpbmVIZWlnaHQ6IFwiNDBweFwiLFxufSk7XG5cbmV4cG9ydCBjb25zdCBBY2NvdW50TG9nbyA9IHN0eWxlZChcImltZ1wiLCB7XG4gIC4uLkFjY291bnRMb2dvU3R5bGUsXG59KTtcbiJdfQ==